export const DANGEROUS_MIME_TYPES = [
  "application/hta",
  "application/inf",
  "application/java-archive",
  "application/javascript",
  "application/macbinary",
  "application/mac-binary",
  "application/marc",
  "application/octet-stream",
  "application/pkix-attr-cert",
  "application/pkix-cert",
  "application/vnd.adobe.air-application-installer-package+zip",
  "application/vnd.adobe.fxp",
  "application/vnd.android.package-archive",
  "application/vnd.apple.installer+xml",
  "application/vnd.fdsn.seed",
  "application/vnd.ms-htmlhelp",
  "application/winhlp",
  "application/x-applescript",
  "application/x-binary",
  "application/x-macbinary",
  "application/x-bytecode.python",
  "application/x-csh",
  "application/x-photoshop",
  "text/x-script.csh",
  "application/x-internett-signup",
  "application/x-msdownload",
  "application/x-msi",
  "application/x-newton-compatible-pkg",
  "application/x-python-code",
  "application/x-sh",
  "application/x-silverlight-app",
  "application/x-sprite",
  "application/x-troff-ms",
  "text/troff",
  "application/x-x509-ca-cert",
  "application/x-x509-user-cert",
  "text/plain",
  "text/xml",
  "video/vdo",
  "video/x-isvideo"
];
